import { render, staticRenderFns } from "./SectionCardImageGrid.vue?vue&type=template&id=ffae4942&scoped=true&"
import script from "./SectionCardImageGrid.vue?vue&type=script&lang=ts&"
export * from "./SectionCardImageGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardImageGrid.vue?vue&type=style&index=0&id=ffae4942&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffae4942",
  null
  
)

export default component.exports